module.exports = __webpack_public_path__ + "static/img/ic_add.94d5cb1e.svg";